import React, { useState } from "react";
import api from "@/lib/api";
import { Upload, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function FileUpload({ context = "general", onUploaded, label = "Upload file", testid = "file-upload" }) {
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(null);

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", f);
    fd.append("context", context);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setUploaded(data);
      onUploaded?.(data);
      toast.success(`Uploaded ${data.filename}`);
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <label className="block cursor-pointer" data-testid={testid}>
      <div className="border border-dashed border-black/40 p-6 text-center hover:bg-black hover:text-white transition group">
        {uploaded ? (
          <div className="flex items-center justify-center gap-2 text-sm">
            <CheckCircle weight="fill" size={20} />
            <span className="truncate max-w-[220px]">{uploaded.filename}</span>
          </div>
        ) : (
          <div className="flex items-center justify-center gap-2 text-sm">
            <Upload size={20} />
            <span>{uploading ? "Uploading…" : label}</span>
          </div>
        )}
      </div>
      <input type="file" className="hidden" onChange={handle} accept="image/*,.pdf" disabled={uploading} />
    </label>
  );
}
